import { useState, useEffect } from 'react'

function isSafariBrowser() {
  if (typeof navigator === 'undefined') return false
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') === -1
}

export default function useIsSafari() {
  const [isSafari, setIsSafari] = useState(false)

  useEffect(() => {
    setIsSafari(isSafariBrowser())
  }, [])

  return isSafari
}
